<template>
  <a-modal
    :open="open"
    title="Enviar correo de prueba"
    okText="Enviar"
    centered
    :confirm-loading="sending"
    @ok="handleOk"
    @cancel="handleClose"
  >
    <section>
      <div class="description">
        <p>
          Envía una versión de prueba a tu dirección o a la de un colega.
          <br />
          Recuerda que:
        </p>
        <ul>
          <li>
            Los correos electrónicos de prueba mostrarán las variables sin ningún valor configurado.
          </li>
        </ul>
      </div>
      <a-form class="form" ref="formRef" layout="vertical" :model="formState">
        <a-form-item name="sender" label="Seleccione el correo del remitente" required>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.sender"
            placeholder="Seleccionar correo"
            :options="mailOptions"
          />
        </a-form-item>

        <a-form-item name="email" label="Ingrese su destinatario" :rules="emailRules">
          <a-input v-model:value="formState.email" placeholder="Escribir correo" />
        </a-form-item>
      </a-form>
    </section>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from "vue";
import { FormInstance, message } from "ant-design-vue";
import { useStore } from "vuex";

import { Template } from "@/@types/flows/emailTemplates";
import { emailRegex } from "@/app/flows/emailTemplates/utils/regex";
import { UserData } from "@/@types/global";
import { emailService } from "@/app/emails/services/Email.service";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";

import HslToHex from "@/app/shared/utils/hslToHex";

const emailRules = [
  { required: true, message: "El destinatario es requerido" },
  {
    pattern: emailRegex,
    message: "El correo no es válido",
  },
];

const props = defineProps<{
  template: Template | undefined;
  open: boolean;
}>();

const emit = defineEmits<{ "update:open": [open: boolean]; update: [] }>();

const store = useStore();

const user = computed<UserData>(() => store.getters["getDataUser"]);

const formRef = ref<FormInstance>();
const formState: { sender: number | undefined; email: string } = reactive({
  sender: undefined,
  email: "",
});

const mailOptions = ref<{ value: number; label: string }[]>([]);

const fetchIdentifiers = async () => {
  const response = await emailService.getEmailsMenuList(user.value.id);

  const identifiers = response.flatMap((i) => i.subItems);

  mailOptions.value = identifiers.map((i) => ({ value: i.id, label: i.email }));
};

onMounted(() => {
  fetchIdentifiers();
});

const handleClose = () => emit("update:open", false);

const sending = ref(false);

const hslToHex = new HslToHex();

const handleOk = async () => {
  await formRef.value?.validate();

  sending.value = true;

  try {
    if (!props.template) throw new Error("No template");
    if (!formState.sender) throw new Error("No sender email");

    console.log(props.template, "props template");
    await emailTemplateService.sendTestMail(
      { ...props.template, template: hslToHex.convertHslToHex(props.template.template) },
      formState.sender,
      formState.email
    );
    message.success("Se envió el correo de prueba");
    handleClose();
  } catch (error) {
    message.error("Ha ocurrido un error");
    console.error(error);
  }

  sending.value = false;
};
</script>

<style scoped lang="sass">
.description
  color: $gray-8
  margin-bottom: 24px

p
  color: $gray-8
  margin-bottom: 0

  &.info
    margin: 0
    margin-top: 2px
    color: $text-tertiary
    text-wrap: pretty

section
  padding: 20px 16px
</style>
